let ProgramRoutes = [
  {
    // 屏位管理
    path: '6001',
    name: '6001',
    component: () => import('@/pages/Program/screenPosition/screenPosition')
  },
  {
    // 节目管理
    path: '6002',
    name: '6002',
    component: () => import('@/pages/Program/programManage/programManage')
  },
  {
    // 节目播放计划
    path: '6003',
    name: '6003',
    component: () => import('@/pages/Program/broadcastPlan/broadcastPlan')
  },
  {
    // 特色菜管理
    path: '6004',
    name: '6004',
    component: () => import('@/pages/Program/dishManage/dishManage')
  }
]

export {
  ProgramRoutes
}



// WEBPACK FOOTER //
// ./src/router/ProgramRoutes.js